import React, { useCallback } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Components Styled
import {
  Container,
  DropDownSelectStyled,
  NavContainer,
  SubContainer,
} from './styles';

// Components
import { Accordion } from '../../../../components/navigation/Accordion';
import { BreadCrumbs } from '../../../../components/navigation/Breadcrumbs';

// Icons
import HomeIcon from '../../../../assets/icons/home.svg';

// Routes utils
import { getOptions } from '../../../../router/definitionGloblaRoutes';
import { createRoutes } from '../../../../router/labelToRoutes';
import { getData } from './routes';
import { filterAllowedRoutes } from '../../../../router/utils';
import { OptionSelected } from '../../../../components/inputs/DropDown/DropDownList/types';

// Styles utils

// Custom hooks
import { useIsSmallDesktop } from '../../../../hooks/useMediaBreakPoints';
import { useAuth } from '../../../../hooks/useAuth';
import { NavigationFallback } from '../../../../components/navigation/NavigationFallback';
import { Role } from '../../../../types/auth';

// Redux
import { roidOTSelectedReset } from '../../../../state/actions/ui/roidOTSelectedGeneralView';

export default function ReportingLayout(): JSX.Element {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const currentRole = useAuth()?.currentRole as Role | null;
  const routes = location.pathname.split('/');
  routes?.shift();

  // Filtra el desplegable de secciones por el rol activo (igual que el resto
  // de Layouts). Sin esto, el `options` crudo mostraba TODAS las secciones
  // —incluidas Gestió/Administració— a roles que no pueden acceder a ellas
  // (p.ej. RoomTeam, que ahora entra a Informes por Comunicaciones Históricas).
  const optionsFiltered = currentRole
    ? filterAllowedRoutes(getOptions(t), currentRole)
    : getOptions(t);

  const routesBreadCrumb = createRoutes(routes, [
    {
      content: <img alt={t('navigation.homePage')} src={HomeIcon} />,
      path: '/',
      pathAbsolute: '/',
    },
  ]);

  const onClickAccordion = useCallback(() => {
    dispatch(roidOTSelectedReset());
  }, []);

  const isSmallDesktop = useIsSmallDesktop();

  return (
    <Container>
      <BreadCrumbs data={routesBreadCrumb} />
      <SubContainer>
        <NavContainer>
          {isSmallDesktop ? null : (
            <>
              <DropDownSelectStyled
                options={optionsFiltered as OptionSelected[]}
                defaultOption={routes[0]}
              />
              <Accordion
                data={getData(t, currentRole)}
                onItemClick={onClickAccordion}
              />
            </>
          )}
        </NavContainer>
        <NavigationFallback>
          <Outlet />
        </NavigationFallback>
      </SubContainer>
    </Container>
  );
}
